import { ContentBox } from "@msuite/ui/content-box";
import { TransportOrdersTable } from "@/components/stock/transport-orders-table";

export function TransportOrders() {
	/** Render */
	return (
		<ContentBox>
			<TransportOrdersTable
				variant="table"
				query={{ scope: "all" }}
			/>
		</ContentBox>
	);
}
